// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1jUfp","doubleRow":"Form_doubleRow__3pnZF","campi":"Form_campi__2mqSc","p":"Form_p__2ldOA","submitBox":"Form_submitBox__3aetG"};